//@ts-check
import { capitalize } from "../../../../assets/js/src/general/utils";

/**
 * @typedef {"outreach" | "conversations" | "data" | "dataRefresh" | "inboxAgent" | "extension" | "sourcing" | "projects"} MarketingLicense
 */

/**
   @param {MarketingLicense} license
 */
export const getIconProps = (license) => {
  const mod = capitalize(license);
  return {
    color: `module${mod}_50`,
    backgroundColor: `module${mod}_5`,
  };
};

export const style = "margin-bottom:16px";
